import React from "react";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import SessionStorage from "../../../../service/storage/SessionStorage";
import CacheStorage from "../../../../service/storage/CacheStorage";
import StorageKeys from "../../../../const/StorageKeys";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import { useDispatch } from "react-redux";
import { removeAllModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";

const DeactivateAccountSuccessAlert = (props: {
  type?: number | undefined;
}) => {
  const dispatch = useDispatch();

  const onCLickCloseAccount = () => {
    SessionStorage.clearAll();
    CacheStorage.clearAll();
    CacheStorage.deleteValue(StorageKeys.login_status);

    dispatch(removeAllModal());
    navigate(appRoutes.routeNameLogin);
  };

  return (
    <Div className="text-center pt-4">
      <div
        className="font-size-20_21 font-gotham-bold color-red2"
        dangerouslySetInnerHTML={{
          __html: AppTranslation.text("deleted_account_success").replaceAll(
            "\n",
            "<br />"
          ),
        }}
      />
      <div
        className="font-size-16_17 font-gotham-book pt-4 pb-5 color-theme-label"
        dangerouslySetInnerHTML={{
          __html: AppTranslation.text(
            "deactivated_account_success_msg"
          ).replaceAll("\n", "<br />"),
        }}
      />
      <ButtonSingle handleClick={() => onCLickCloseAccount()}>
        {AppTranslation.text("ok")}
      </ButtonSingle>
    </Div>
  );
};

export default DeactivateAccountSuccessAlert;
